import './MenuItem.css'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconName } from '@fortawesome/fontawesome-svg-core'
import { Nav, NavDropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { MenuItemDto } from '@v1UsersApi'

interface IProps {
  item: MenuItemDto,
  depth: number
}

const MenuItem = ({ item, depth }: IProps) => {
  // logic to figure out if the url is to the spa or we need full url to old DCS
  function getUrl() {
    let newUrl = item.tabUrl ?? ''
    if (item.newDcsUrl || !item.tabUrl || item.tabUrl === '#') {
      newUrl = item.tabUrl ?? ''
    }
    else if (newUrl.startsWith('http'))
      newUrl = item.tabUrl
    else {
      if (!newUrl.startsWith('/'))
        newUrl = `/${newUrl}`
      newUrl = `${process.env.REACT_APP_OLD_SYS_ADMIN_URL}/web${newUrl}`
    }

    return item.menuItems && item.menuItems.length > 0 ? '#' : newUrl || '#'
  }

  // Use a separate component like this so that we don't have to have a root element.
  const ConditionalMenuItem = () => {
    if (item.menuItems && item.menuItems.length === 0) {
      //if depth is greater than one we are inside of a nested dropdown
      if (depth > 1) {
        // use react router link component so it doesn't post back for new spa urls
        if (item.newDcsUrl)
          return (
            <NavDropdown.Item as={Link} to={getUrl()} eventKey={`${item.tabId}-${item.tabName}`}>
              <span>{item.tabName}</span>
            </NavDropdown.Item>
          )

        // use anchor tag so correctly redirects to full url
        else return (
          <NavDropdown.Item href={getUrl()} eventKey={`${item.tabId}-${item.tabName}`}>
            <span>{item.tabName}</span>
          </NavDropdown.Item>
        )
      }

      // use react router link component so it doesn't post back for new spa urls
      if (item.newDcsUrl)
        return (
          <Nav.Item as='li'>
            <Nav.Link as={Link} to={getUrl()} eventKey={`${item.tabId}-${item.tabName}`}>
              <span>{item.tabName}</span>
            </Nav.Link>
          </Nav.Item>)

      // use anchor tag so correctly redirects to full url
      else
        return (
          <Nav.Item as='li'>
            <Nav.Link href={getUrl()} eventKey={`${item.tabId}-${item.tabName}`}>
              <span>{item.tabName}</span>
            </Nav.Link>
          </Nav.Item>
        )
    }

    // is a drop down menu
    return (
      <NavDropdown
        as={depth > 1 ? 'div' : 'li'}
        id={`drop-down-${item.tabName?.replaceAll(' ', '').toLowerCase()}-depth-${depth}`} // is required and needs to be unique
        drop={depth > 1 ? 'end' : undefined} // if depth greater than one its a sub-menu so show it on the right
        title={<>{item.tabName}</>}
      >
        {item.menuItems && item.menuItems.map((subItem: MenuItemDto, index: number) => (<MenuItem key={index} item={subItem} depth={depth + 1} />))}
      </NavDropdown>
    )
  }


  return (<ConditionalMenuItem />)

}
export default MenuItem